import { useState, useEffect } from 'react';
import { Outlet, useParams, useNavigate } from 'react-router-dom';
import { projectService } from '../../services/dataService';
import toast from 'react-hot-toast';

/**
 * Wrapper layout for construction phase pages.
 * Loads the project and passes it to child routes via Outlet context,
 * maintaining compatibility with existing pages that use useOutletContext().
 */
export default function ConstructionLayout() {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const res = await projectService.get(projectId);
        setProject(res.data.data.project || res.data.data);
      } catch {
        toast.error('Project not found');
        navigate('/app/projects');
      } finally {
        setLoading(false);
      }
    };
    fetchProject();
  }, [projectId, navigate]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!project) return null;

  // Pages read projectId straight off the outlet context, so it has to be here —
  // without it every child page fetched /projects/undefined/....
  return <Outlet context={{ projectId, project, setProject }} />;
}
